import {
  loadHolidays,
  loadHolidaysFail,
  loadHolidaysSuccess,
} from '../actions/holidays.actions';
import { createReducer, on } from '@ngrx/store';
import { BoelsGenericState, BoelsReservation } from '@boels/models';

export interface HolidaysState extends BoelsGenericState {
  holidays: BoelsReservation | undefined;
}

export const initialHolidaysState: HolidaysState = {
  holidays: undefined,
  loading: false,
  success: false,
  error: false,
};

export const reducer = createReducer(
  initialHolidaysState,
  on(loadHolidays, (state, { startDate, endDate }) => ({
    ...state,
    startDate,
    endDate,
    success: false,
    loading: true,
    error: false,
  })),
  on(loadHolidaysSuccess, (state, { holidays }) => ({
    ...state,
    holidays,
    success: true,
    loading: false,
    error: false,
  })),
  on(loadHolidaysFail, (state) => ({
    ...state,
    success: false,
    loading: false,
    error: true,
  })),
);
